import {UIHomepageCTAController} from '../home_page/UIHomepageCTAController'
import {UIManager} from '../UIManager'
import {UIMainPageOverviewController} from './UIMainPageOverviewController'
import {UIMainPageRankedActionsController} from './UIMainPageRankedActionsController'
import {UIHomepageLeftStoreAdController} from '../home_page/UIHomepageLeftStoreAdController'
import {UIHomepageRightStoreAdController} from '../home_page/UIHomepageRightStoreAdController'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'

export class UIMainPageController {
    private readonly uiManager: UIManager
    ctaController: UIHomepageCTAController
    private readonly leftStoreAdController: UIHomepageLeftStoreAdController
    private readonly rightStoreAdController: UIHomepageRightStoreAdController

    private readonly mainPageContainerDiv: HTMLDivElement
    constructor(uiManager: UIManager) {
        this.uiManager = uiManager

        this.ctaController = new UIHomepageCTAController(this.uiManager)
        this.leftStoreAdController = new UIHomepageLeftStoreAdController()
        this.rightStoreAdController = new UIHomepageRightStoreAdController()
        this.mainPageContainerDiv = document.getElementById('scene_mainpage_mid') as HTMLDivElement

        void this.init()
    }

    private async init() {
        await ClientUserState.waitUntilFresh

        new UIMainPageOverviewController()
        new UIMainPageRankedActionsController(this.uiManager)
    }

    hide() {
        this.mainPageContainerDiv.style.display = 'none'
    }

    show() {
        this.mainPageContainerDiv.style.display = 'flex'
        this.uiManager.adController.showLobbyVerticalAds()
    }
}
